import { TKIconCamera, TKIconDPFull, TKIconPencil } from "assets/images/svgs";
import React, { useState } from "react";
import InputField from "shared/InputField";

const NGOInformation = ({ ngoProfile }) => {
  const [editing1, setEditing1] = useState(false);
  const [editing2, setEditing2] = useState(false);

  return (
    <div className="bg-white rounded-md p-8 w-full h-full">
      <div className="flex max-[560px]:flex-col gap-x-4 border-b">
        <div className="w-fit relative">
          <label className="cursor-pointer">
            <TKIconDPFull />
            <div className="absolute bottom-8 right-0 bg-[#213874] p-1 rounded-full">
              <TKIconCamera />
            </div>
            <input className="hidden" type="file" />
          </label>
        </div>
        <div>
          <p className="font-semibold">Peace Charity NGO</p>
          <p className="text-[#7A7A7A]">info@charityngo.com</p>
        </div>
      </div>
      <div>
        <p className="my-4 font-semibold">NGO Details</p>
        <form>
          <div className="flex justify-between gap-3 flex-wrap">
            <div className="w-[422px] flex flex-col gap-y-4">
              <div className="flex-auto flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Name of NGO
                </label>
                <InputField
                  disabled={!editing1}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type="text"
                  defaultValue={ngoProfile?.ngoProfile?.name}
                  name="ngoName"
                  id="ngoName"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Statement of purpose
                </label>
                <textarea
                  disabled={!editing1}
                  className="px-2 py-1 bg-[#F6F6F6F6]  rounded-md placeholder:text-[14px] placeholder:text-[#212121]"
                  rows="5"
                  name="ngoStatement"
                  defaultValue={ngoProfile?.ngoProfile?.statement_of_purpose}
                  placeholder="Please provide the following details"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Email
                </label>
                <InputField
                  disabled={!editing1}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121]"
                  type="email"
                  defaultValue={ngoProfile?.ngoProfile?.ngo?.email}
                  name="ngoEmail"
                  id="ngoEmail"
                />
              </div>
            </div>
            <div className="w-[422px] flex flex-col gap-y-4">
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  NGO Contact
                </label>
                <InputField
                  disabled={!editing1}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type="text"
                  defaultValue="+234 901234567890"
                  name="ngoContact"
                  id="ngoContact"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  About your NGO
                </label>
                <textarea
                  disabled={!editing1}
                  className="px-2 py-1 bg-[#F6F6F6F6]  rounded-md placeholder:text-[14px] placeholder:text-[#212121]"
                  rows="5"
                  name="aboutNGO"
                  defaultValue={ngoProfile?.ngoProfile?.about}
                  placeholder="Please provide the following details"
                />
              </div>
            </div>
          </div>
          <div
            className={`my-6 flex "justify-between"
            }`}
          >
            {!editing1 && (
              <div
                onClick={() => setEditing1(!editing1)}
                className="cursor-pointer w-[80px] flex justify-center items-center border rounded-2xl gap-x-1 p-1 border-[#213874] hover:font-medium"
              >
                <TKIconPencil />
                <p className="text-[#213874]">Edit</p>
              </div>
            )}
            {editing1 && (
              <div className={`flex gap-x-2`}>
                <button
                  onClick={() => setEditing1(!editing1)}
                  type="button"
                  className="w-[100px] bg-[#E0E0E0] p-2 rounded-sm"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="w-[100px] text-white bg-[#61CE70] p-2 rounded-sm"
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      <div>
        <p className="mt-8 mb-6 font-semibold">NGO Address</p>
        <form>
          <div className="flex justify-between gap-3 flex-wrap">
            <div className="w-[422px] flex flex-col gap-y-4">
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Address
                </label>
                <InputField
                  disabled={!editing2}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type="text"
                  defaultValue="3rd ave F1 close"
                  name="ngoAddress"
                  id="ngoAddress"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[14px] text-[rgb(122,122,122)] font-normal">
                  State
                </label>
                <InputField
                  disabled={!editing2}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type="text"
                  defaultValue="Lagos"
                  name="ngoState"
                  id="ngoState"
                />
              </div>
            </div>
            <div className="w-[422px] flex flex-col gap-y-4">
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Province
                </label>
                <InputField
                  disabled={!editing2}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type="text"
                  defaultValue="Lekki"
                  name="ngoProvince"
                  id="ngoProvince"
                />
              </div>
              <div className="flex flex-col">
                <label className="text-[14px] text-[#7A7A7A] font-normal">
                  Country
                </label>
                <InputField
                  disabled={!editing2}
                  className="!bg-[#F6F6F6F6] rounded-md placeholder:text-[#212121] "
                  type="text"
                  defaultValue="Nigeria"
                  name="ngoCountry"
                  id="ngoCountry"
                />
              </div>
            </div>
          </div>
          <div className={`my-6 flex "justify-between"`}>
            {!editing2 && (
              <div
                onClick={() => setEditing2(!editing2)}
                className="cursor-pointer w-[80px] flex justify-center items-center border rounded-2xl gap-x-1 p-1 border-[#213874] hover:font-medium"
              >
                <TKIconPencil />
                <p className="text-[#213874]">Edit</p>
              </div>
            )}
            {editing2 && (
              <div className="flex gap-x-2">
                <button
                  onClick={() => setEditing2(!editing2)}
                  type="button"
                  className="w-[100px] bg-[#E0E0E0] p-2 rounded-sm"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="w-[100px] text-white bg-[#61CE70] p-2 rounded-sm"
                >
                  Save
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
      <div></div>
    </div>
  );
};

export default NGOInformation;
